import React from 'react';
export function SkeletonTable() {
  return <div className="w-full animate-pulse" data-id="element-106">
      {/* Action Bar Skeleton */}
      <div className="flex items-center justify-between p-4 border-b border-slate-200 bg-slate-50/50" data-id="element-107">
        <div className="flex items-center gap-3" data-id="element-108">
          <div className="w-36 h-9 bg-slate-200 rounded-lg" data-id="element-109"></div>
        </div>
        <div className="flex items-center gap-3" data-id="element-110">
          <div className="w-48 h-9 bg-slate-200 rounded-lg" data-id="element-111"></div>
          <div className="w-9 h-9 bg-slate-200 rounded-lg" data-id="element-112"></div>
        </div>
      </div>

      {/* Table Header Skeleton */}
      <div className="flex items-center px-6 py-3 border-b border-slate-200 bg-slate-50 gap-4" data-id="element-113">
        <div className="w-4 h-4 bg-slate-200 rounded flex-shrink-0" data-id="element-114"></div>
        <div className="w-5 h-4 bg-transparent flex-shrink-0" data-id="element-115"></div>
        <div className="flex-1 h-3 bg-slate-200 rounded max-w-[80px]" data-id="element-116"></div>
        <div className="w-28 h-3 bg-slate-200 rounded flex-shrink-0" data-id="element-117"></div>
        <div className="w-28 h-3 bg-slate-200 rounded flex-shrink-0" data-id="element-118"></div>
        <div className="w-24 h-3 bg-slate-200 rounded flex-shrink-0 hidden sm:block" data-id="element-119"></div>
        <div className="w-24 h-3 bg-slate-200 rounded flex-shrink-0 hidden lg:block" data-id="element-120"></div>
      </div>

      {/* Table Rows Skeleton */}
      {[...Array(6)].map((_, i) => <div key={i} className="flex items-center px-6 py-4 border-b border-slate-100 gap-4" style={{
      opacity: 1 - i * 0.12
    }} data-id="element-121">
          <div className="w-4 h-4 bg-slate-200 rounded flex-shrink-0" data-id="element-122"></div>
          <div className="w-5 h-5 bg-slate-100 rounded flex-shrink-0" data-id="element-123"></div>
          <div className="flex-1 space-y-1.5" data-id="element-124">
            <div className="h-4 bg-slate-200 rounded" style={{
          width: `${65 - i * 5}%`
        }} data-id="element-125"></div>
          </div>
          <div className="w-28 h-4 bg-slate-200 rounded flex-shrink-0" data-id="element-126"></div>
          <div className="w-28 h-4 bg-slate-200 rounded flex-shrink-0" data-id="element-127"></div>
          <div className="w-24 h-4 bg-slate-200 rounded flex-shrink-0 hidden sm:block" data-id="element-128"></div>
          <div className="w-24 h-4 bg-slate-200 rounded flex-shrink-0 hidden lg:block" data-id="element-129"></div>
        </div>)}
    </div>;
}